










































































































































































































































































































import { Vue, Component, Prop, Watch } from "../vue-ext";

import {
    transportTaskService,
    transportExecuteService,
    waybillManageService
} from "../services";

import {
    TransportDeviation,
    TransportLoad,
    TransportLoadTask,
    TransportTaskUnit,
    TransportVehicle,
    Waybill,
    WaybillState,
} from "../models";

import AddressCard from "./AddressCard.vue";
import DeviationDialog from "./DeviationDialog.vue";
import LoadExecutionDialog from "./LoadExecutionDialog.vue";
import PlanTaskDialog from "./PlanTaskDialog.vue";
import TaskStartedDialog from "./TaskStartedDialog.vue";
import TaskTransportingDialog from "./TaskTransportingDialog.vue";
import TaskViewDeviations from "./TaskViewDeviations.vue";

import taskStateColors from "../taskstates";

@Component({
    components: {
        AddressCard,
        DeviationDialog,
        LoadExecutionDialog,
        PlanTaskDialog,
        TaskStartedDialog,
        TaskTransportingDialog,
        TaskViewDeviations,
    }
})
export default class TaskView extends Vue {
    @Prop() item!: { load: TransportLoad; loadTask: TransportLoadTask };
    @Prop() vehicle!: TransportVehicle;
    @Prop() favoriteVehiclesOnly!: boolean;

    get task() {
        return this.item.loadTask.task;
    }

    get taskUnits(): TransportTaskUnit[] {
        return this.task.units;
    }

    get taskLeaveUnits(): TransportTaskUnit[] {
        return this.task.units.filter(i => i.direction === "Deliver");
    }

    get taskTakeUnits(): TransportTaskUnit[] {
        return this.task.units.filter(i => i.direction !== "Deliver");
    }

    get canPlan(): boolean {
        return this.auth.roles && (this.auth.roles.indexOf("Mobisulo.TaskPlan") !== -1 || this.auth.roles.indexOf("Mobisulo.KKAdmin") !== -1);
    }

    saving = false;

    startedVisible = false;
    transportingVisible = false;
    loadExecutionVisible = false;
    planTaskDialogVisible = false;
    deviation: null | { defer: boolean } = null;

    waybillUrlBase: null | string = null;
    waybill: null | { waybill: null | Waybill } = null;
    deviations: null | TransportDeviation[] = null;

    imageDialog = { visible: false, url: null };

    get waybillEnabled() {
        return this.task.waybillEnabled && this.vehicle.useWaybill;
    }

    get waybillReady() {
        return !this.waybillEnabled || this.waybill;
    }

    get waybillUrl() {
        return this.waybillUrlBase + "?source=Mobisulo&returnUrl=" + encodeURIComponent(location.href);
    }

    get waybillState(): WaybillState {
        if (!this.waybill || !this.waybill.waybill || !this.waybill.waybill.revisions[0]) {
            return "Missing";
        }

        return this.waybill.waybill.revisions[0].state;
    }

    get waybillColor(): string {
        return taskStateColors[this.waybillState];
    }

    taskStateColors = taskStateColors;

    panels = [0, 1, 2, 3];

    async mounted() {
        await this.changed();
    }

    get allLoadTasksReady() {
        return !this.item.load.loadTasks.find(lt => lt.task && lt.task.state !== "Ready");
    }

    @Watch("item")
    async changed() {
        // TODO clear all fields

        setTimeout(() => {
            this.loadExecutionVisible = this.allLoadTasksReady && this.item.load.loadState !== "Done";
        });

        // TODO cancel

        if (this.waybillEnabled) {
            this.loadWaybill();
        }
    }

    async loadWaybill() {
        const waybillLoad = (await waybillManageService.getWaybillLoad(this.item.load.loadId));
        this.waybillUrlBase = waybillLoad.extraUrl;

        const taskId = this.item.loadTask.task.taskId;
        const waybill = waybillLoad.waybills.find(w => w.taskIds.find(id => taskId));
        this.waybill = { waybill: waybill || null };
    }

    async start() {
        this.saving = true;
        await transportExecuteService.startedTask(this.task.taskId, { taskTypeId: null });
        this.$emit("reload");
    }

    async complete() {
        this.saving = true;
        await transportExecuteService.readyTask(this.task.taskId, {});
        this.$emit("reload");
    }

    async revertTask() {
        this.saving = true;
        await transportExecuteService.revertTask(this.task.taskId, {});
        this.$emit("reload");
    }

    async deferTask() {
        this.deviation = { defer: true };
    }

    async planTask() {
        this.planTaskDialogVisible = true;
    }

    async planTaskDialogSaveAndClose() {
        this.planTaskDialogVisible = true;
        this.$emit("reload");
    }

    getHoursAndMinsStr(value: number): string {
        if (!value) {
            return "";
        }
        const hours = Math.floor(value);
        const mins = Math.round((value - hours) * 60);
        return (hours ? hours.toString(10) + " h " : "") + mins.toString(10) + " min";
    }
}
